import '../styles/index.css'

import $ from 'jquery';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick.js';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/owl.carousel.js';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import 'jquery-confirm/dist/jquery-confirm.min.css';
import 'jquery-confirm/dist/jquery-confirm.min.js';

import 'lightgallery/dist/css/lightgallery.css';
import 'lightgallery/dist/js/lightgallery';
import 'lightgallery/modules/lg-thumbnail.js';

const _dir = $('html').attr('dir');
((
    ($) => {
        let prevArrow = '';
        let nextArrow = '';
        if (_dir === 'rtl') {
            prevArrow = 'icon-keyboard_arrow_left';
            nextArrow = 'icon-keyboard_arrow_right';
        } else {
            prevArrow = 'icon-keyboard_arrow_right';
            nextArrow = 'icon-keyboard_arrow_left';
        }

        $('.list-1').slick({
            dots: false,
            infinite: true,
            nav: true,
            navElement: 'div',
            rtl: (_dir === "rtl"),
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<div id="list-1-arrow-right"><i class=' + prevArrow + '></i></div>',
            nextArrow: '<div id="list-1-arrow-left"><i class=' + nextArrow + '></i></div>',
        });
        $('.list-2').slick({
            dots: false,
            infinite: true,
            nav: true,
            navElement: 'div',
            rtl: (_dir === "rtl"),
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            prevArrow: '',
            nextArrow: '',
            responsive: [
                {
                    breakpoint: 1300,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        prevArrow: '<div id="list-2-arrow-right" class="list-2-arrow"><i class=' + prevArrow + '></i></div>',
                        nextArrow: '<div id="list-2-arrow-left" class="list-2-arrow"><i class=' + nextArrow + '></i></div>',

                    }
                },
            ]
        });
        $('.list-5').slick({
            dots: false,
            infinite: true,
            nav: true,
            navElement: 'div',
            rtl: (_dir === "rtl"),
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<div id="list-5-arrow-right"><i class=' + prevArrow + '></i></div>',
            nextArrow: '<div id="list-5-arrow-left"><i class=' + nextArrow + '></i></div>',
        });
        $('.list-6-slider').slick({
            dots: false,
            infinite: true,
            nav: true,
            navElement: 'div',
            rtl: (_dir === "rtl"),
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<div id="list-5-arrow-right"><i class=' + prevArrow + '></i></div>',
            nextArrow: '<div id="list-5-arrow-left"><i class=' + nextArrow + '></i></div>',
        });
        $('.list-8').slick({
            dots: false,
            infinite: true,
            nav: true,
            navElement: 'div',
            rtl: (_dir === "rtl"),
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<div id="list-8-arrow-right"><i class=' + prevArrow + '></i></div>',
            nextArrow: '<div id="list-8-arrow-left"><i class=' + nextArrow + '></i></div>',
        });
        $(window).on('scroll', function (e) {
            let y = $(window).scrollTop();
            if (y > 80) {
                placeTool(true);
                $('.header-sec-2').addClass('header-on-scroll');
                $('.social-links').addClass('on-scroll');
                // $('.accessibility-toolbar').addClass('on-scroll');
            } else {
                placeTool(false);
                $('.header-sec-2').removeClass('header-on-scroll');
                $('.social-links').removeClass('on-scroll');
                // $('.accessibility-toolbar').removeClass('on-scroll');
            }
        });
        // tabs('.tabs1');
        $('#list-1-arrow-right').appendTo('#list-1-nav');
        $('#list-1-arrow-left').appendTo('#list-1-nav');
        $.ajax({
            url: application.url.fetchMap,
            method: 'get',
            success: function (response) {
                $('#blocks-bottom-1').html(response);
            }
        });
        let _sub_menu = $('.main-menu ul li>ul>li>ul');
        if (_sub_menu.length > 0) {
            _sub_menu.parent().parent().addClass('two-subs');
        }
        $('#apply-job,#popup-2-exit').on('click', function (e) {
            e.preventDefault();
            $('.popup-2,#inner-overlay').toggleClass('full-height');
        });
        let job_title = $('#page-1-title').data('name');
        $('input#job-title').val(job_title);

        $.fn.validateForm = function () {
            let _form = $(this);
            _form.submit(function (e) {
                e.preventDefault();
                $.ajax({
                    url: _form.attr('action'),
                    data: _form.serialize(),
                    method: "post",
                    dataType: 'json',
                    beforeSend: function () {
                        _form.find('.loader-1').fadeIn();
                    },
                    success: function (results) {
                        let _title = application.translations.confirmation;
                        if (_form.attr('id') === 'subscribe-newsletter') {
                            _title = '';
                        }
                        _form.find('.required-label').remove();
                        _form.find('input, select, textarea').val("");
                        _form.find('.media--uploads-list').empty();
                        $.confirm({
                            title: _title,
                            content: results.message,
                            type: 'green',
                            buttons: {
                                ok: {
                                    text: application.translations.ok,
                                    btnClass: 'btn-primary',
                                    keys: ['enter'],
                                    action: function () {
                                        return true;
                                    }
                                }
                            }
                        });
                    },
                    error: function (response) {
                        let _response = response.responseJSON;
                        let _errors = _response.errors;
                        _form.find('.required-label').remove();
                        // console.log(_errors);
                        $.each(_errors, function (_element, _message) {
                            // let _error_label = application.translations.required;
                            console.log(_message);
                            let _error_label = _message;
                            let _field;
                            if (_element === 'recaptcha') {
                                _field = _form.find(`.${_element}`);
                            } else {
                                _field = _form.find('[name="' + _element + '"]');
                            }
                            // console.log(_field);
                            let _requiredLabelWrapper = _field.closest('.input--wrapper');
                            let _requiredLabel = _requiredLabelWrapper.find('.required-label');
                            if (_requiredLabel.length === 0) {
                                _requiredLabelWrapper.append('<span class="required-label">' + _error_label + '</span>');
                            }
                        });
                    },
                    complete: function () {
                        _form.find('.loader-1').fadeOut();
                    }
                });
            });
        };
        $('#apply-job-form').validateForm();


        $.fn.validateMyForms = function () {
            let _form = $(this);
            _form.submit(function (e) {
                e.preventDefault();
                $.ajax({
                    url: _form.attr('action'),
                    data: _form.serialize(),
                    method: "post",
                    dataType: 'json',
                    beforeSend: function () {
                        _form.find('.loader-1').fadeIn();
                    },
                    success: function (results) {
                        let _title = application.translations.confirmation;
                        _form.find('.required-label').remove();
                        _form.find('input, select, textarea').val("");
                        $.confirm({
                            title: _title,
                            content: results.message,
                            type: 'green',
                            buttons: {
                                ok: {
                                    text: application.translations.ok,
                                    btnClass: 'btn-primary',
                                    keys: ['enter'],
                                    action: function () {
                                        return true;
                                    }
                                }
                            }
                        });
                    },
                    error: function (response) {
                        let _response = response.responseJSON;
                        let _errors = _response.errors;
                        _form.find('.required-label').remove();
                        $.each(_errors, function (_element, _message) {
                            let _error_label = _message;
                            let _field;
                            if (_element === 'recaptcha') {
                                _field = _form.find(`.${_element}`);
                            } else {
                                _field = _form.find('[name="' + _element + '"]');
                            }
                            // let _error_label = application.translations.required;
                            let _requiredLabelWrapper = _field.closest('[class*="-control"]');
                            let _requiredLabel = _requiredLabelWrapper.find('.required-label');
                            if (_requiredLabel.length === 0) {
                                _requiredLabelWrapper.append('<span class="required-label">' + _error_label + '</span>');
                            }
                        });
                    },
                    complete: function () {
                        _form.find('.loader-1').fadeOut();
                    }
                });
            });
        };
        $('#newsletter-form').validateMyForms();
        $('#contact-us-form').validateMyForms();
        $('#upload-cv button').text(application.translations.upload_cv);
        matrixAddLabel();
        $('.matrix-add-row').on('click', function () {
            matrixAddLabel()
        });

        function matrixAddLabel() {
            $('.disabled_matrix_field').prop('disabled', true);
        }

        $('#search-btn').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('toggled');
            $('#side-search').toggleClass('translate-form');
        });
        if ($(window).width() < 600) {
            $(_list_7_selector).remove();
            let _list_7_selector = $('.list-7-sec-2');
            $('.list-7-sec-1 .columns').append(_list_7_selector);
        }
        $('#icon-menu,#menu-icon-cross,#body-overlay').on('click', function (e) {
            $('.responsive-menu').toggleClass('active');
            $('.body-overlay').toggleClass('active');
            $('body').toggleClass('overflow-hidden');
        });


        $('.responsive-menu-content a').click(function (e) {
            let _clicked = $(this);
            let _sub = _clicked.parent().find('> ul');
            if (_sub.length) {
                e.preventDefault();
                if (_sub.css('display') === 'none') {
                    _sub.slideDown();
                } else {
                    _sub.slideUp();
                }
            }
        });

        $('.hide-first-img').find('img').first().hide();

        $('body').on('click', '#fullScreenMap', function (e) {
            e.preventDefault();
            let _clicked = $(this);
            let _map = $('.popup1');
            let _loaded = _clicked.data('loaded');
            if (typeof _loaded !== undefined && _loaded === false) {
                let _url = _clicked.data('url');
                $.ajax({
                    url: _url,
                    method: "GET",
                    success: function (response) {
                        _map.html(response);
                        _clicked.data('loaded', true);
                        $('.body-overlay-2').fadeIn();
                        _map.fadeIn();
                    }
                });
            }
            $('.body-overlay-2').fadeIn();
            _map.fadeIn();
        });

        $('body').on('click', '.body-overlay-2', function (e) {
            $('.body-overlay-2').fadeOut();
            $('.popup1').fadeOut();
        });

        $(".lightgallery").lightGallery({
            thumbnail: true
        });

        $('[data-open]').click(function (e) {
            e.preventDefault();
            let _clicked = $(this);
            let _popUpClass = _clicked.attr('data-open');
            $(`.${_popUpClass}`).stop().fadeIn();
            $(`.${_popUpClass}-overlay`).stop().fadeIn();
        });

        $('[data-close]').click(function (e) {
            e.preventDefault();
            let _clicked = $(this);
            let _popUpClass = _clicked.attr('data-close');
            $(`.${_popUpClass}`).stop().fadeOut();
            $(`.${_popUpClass}-overlay`).stop().fadeOut();
        });

        $('#main_cat').change(function () {
            let _select = $(this);
            let _value = _select.val();
            let _url = _select.data('url');
            let _subs = $('#sub_cat');
            if (_value.length > 0) {
                $.ajax({
                    url: _url,
                    dataType: 'JSON',
                    method: 'GET',
                    data: {
                        catId: _value
                    },
                    beforeSend: function () {
                        _subs.addClass('sending');
                    },
                    success: function (response) {
                        _subs.find('option:not(#label)').remove();
                        if (response.html.length > 0) {
                            _subs.append(response.html);
                            _subs.removeClass('hide');
                        } else {
                            _subs.addClass('hide');
                        }
                    },
                    error: function () {
                        _subs.find('option:not(#label)').remove();
                        _subs.addClass('hide');
                    },
                    complete: function () {
                        _subs.removeClass('sending');
                    }
                });
            }
        });

        let _sH = 0;
        placeTool(false);

        function placeTool(large) {
            let _tool = $('.accessibility-toolbar');
            if (_tool.length > 0) {
                let _social = $('.social-links');
                if (_social.length > 0) {
                    if (large) {
                        _tool.css('top', _tool.css('top') + _social.outerHeight());
                    } else {
                        let _topEdge = _social.offset().top;
                        _sH = _social.outerHeight();
                        let _bottomEdge = _topEdge + _sH;
                        _tool.css('top', _bottomEdge + 50);
                    }
                }
            }
        }

    }
)(jQuery));